import { ref } from 'vue'

// ⇧⌘N («Новый канал») asks the group sidebar (GroupInfo.vue) — which owns the per-category create
// dialogs — to open one. A counter, so asking twice in a row still reaches its watcher.
const requests = ref(0)

export function useCreateChannelRequest() {
  return {
    requests,
    request: () => { requests.value++ },
  }
}
